<form
  class="pt-comment-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>

  <div class="pt-comment-form__control">
    <div  class="pt-comment-form__emoji">
      <button
        type="button"
        puButton
        size="s"
        uiType="quaternary"
        #dropdownRef="puDropdownTrigger"
        [puDropdownTriggerFor]="emojiMart"
        [autoOverlayPosition]="true"
        [offsetY]="30"
      >
        <pu-icon
          iconName="add-emoji"
          size="20"
        />
      </button>

      <pu-dropdown
        #emojiMart
        [closeOnClick]="false"
      >
        <emoji-mart
          [darkMode]="uiStore.isDarkTheme()"
          [isNative]="true"
          (emojiSelect)="selectEmoji($event)"
        />
      </pu-dropdown>
    </div>

    <pu-text-area
      controlId="commentFormText"
      formControlName="content"
      [maxLength]="1000"
      [rows]="3"
      [placeholder]="'blog.post.commentForm.control.comment' |translate"
    />

    <button
      class="pt-comment-submit"
      type="submit"
      puButton
      size="m"
      uiType="primary"
      [disabled]="!form.controls.content.value"
    >
      {{ 'blog.post.commentForm.control.send' | translate }}
    </button>
  </div>
</form>
